module.exports = __webpack_public_path__ + "static/media/img-right.19f466a4.svg";